import { render, staticRenderFns } from "./FormDetailView.vue?vue&type=template&id=4c895cb9&scoped=true&"
import script from "./FormDetailView.vue?vue&type=script&lang=js&"
export * from "./FormDetailView.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailView.vue?vue&type=style&index=0&id=4c895cb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c895cb9",
  null
  
)

export default component.exports